import React, { useContext } from "react";
import { useState } from "react";
import AppContext from "../../AppContext";
import msalInstance, { BASE_URL, Client_id } from "../../constant";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "react-google-login";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useTranslation, Trans } from "react-i18next";

const Login = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState({
    userName: false,
    password: false,
    passwordIncorrect: false,
  });
  const { t } = useTranslation();
  const [user, setUser] = useState({ userName: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [company, setCompany] = useState();
  const [companies, setCompanies] = useState([]);
  const [auth, setAuth] = useState();
  const { authCtx } = useContext(AppContext);

  const msSignIn = async () => {
    setLoading(true);
    try {
      const response = await msalInstance.loginPopup({
        scopes: ["user.read"],
      });
      const res = await axios.post(
        `${BASE_URL}/Auth/SingleSignOn?email=${response.account.username}`
      );
      setLoading(false);
      // if (res.data.resetPassword === true) {
      //   navigate(`/changePassword/${res.data.id}`);
      // } else {
      if (res.status === 200 && res.data) {
        if (res.data.role === 100) {
          setAuth(res.data);
          loadCompanies();
          setSuperAdmin(true);
        } else authCtx.login(res.data);
        setCookie("GD-RMS-MS-Profile", JSON.stringify(response.tokenId), 7);
      } else {
        setValidate((pre) => ({
          ...pre,
          errorMessage: "This user is not active",
        }));
      }
      console.log("Microsoft Sign In Response:", response);
      // Handle response and user authentication
    } catch (err) {
      setValidate((pre) => ({
        ...pre,
        errorMessage: err?.response?.data?.message,
      }));
      console.error("Microsoft Sign In Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const responseGoogleSuccess = async (response) => {
    setLoading(true);
    authCtx.isLoading = true;
    try {
      const res = await axios.post(
        `${BASE_URL}/Auth/SingleSignOn?email=${response.profileObj.email}`
      );
      setLoading(false);
      if (res.data.role === 100) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.token}`;
        setAuth(res.data);
        loadCompanies();
        setSuperAdmin(true);
      } else authCtx.login(res.data);
      setCookie("GD-RMS-Profile", JSON.stringify(response.tokenId), 7);
    } catch (err) {
      console.log(err.response.data.message, "err");
      setValidate((pre) => ({
        ...pre,
        errorMessage: err.response.data.message,
      }));
    } finally {
      authCtx.isLoading = false;
      setLoading(false);
    }
  };

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  const responseGoogleFailure = (error) => {
    console.error("Login Failed:", error);
    // Handle failed login, e.g., display error message or redirect to login page
  };

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onLoginClick = async (e) => {
    e.preventDefault();
    if (user.userName === "" || user.password === "") {
      setValidate((pre) =>
        user.userName === ""
          ? { ...pre, userName: true }
          : { ...pre, userName: false }
      );
      setValidate((pre) =>
        user.password === ""
          ? { ...pre, password: true }
          : { ...pre, password: false }
      );
    } else {
      setValidate({
        userName: false,
        password: false,
        passwordIncorrect: false,
      });
      setLoading(true);
      try {
        const res = await axios.post(`${BASE_URL}/Auth/login`, user);
        setLoading(false);
        if (res.data.resetPassword === true) {
          navigate(`/changePassword/${res.data.id}`);
        } else {
          if (res.data.role === 100) {
            setAuth(res.data);
            loadCompanies();
            setSuperAdmin(true);
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${res.data.token}`;
          } else authCtx.login(res.data);
        }
      } catch (err) {
        setLoading(false);
        setValidate((pre) => ({ ...pre, passwordIncorrect: true }));
      }
    }
  };

  const onCompanySubmit = () => {
    const companyAuth = { ...auth, companyId: company.id };
    authCtx.login(companyAuth);
  };

  const loadCompanies = async () => {
    const res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      setCompanies(res.data);
    }
  };

  return (
    <div className="h-full">
      <div className="flex">
        <div className="sm:w-1/2 lg:w-2/3 sm:block hidden relative">
          <img
            className="loginImg h-screen -ml-3 object-cover"
            src="loginPicture.svg"
            alt="loginPicture"
          />
          <div className="absolute top-1/4 lg:left-28 left-12 pr-5 text-white flex flex-col gap-6">
            <label className="lg:text-4.5xl text-2xl lg:leading-12 leading-8">
              <Trans i18nKey="login.header1">{t("login.header1")}</Trans>
            </label>
            <label className="lg:text-2xl text-base font-medium">
              {t("login.header2")}
            </label>
          </div>
        </div>
        <form className="sm:w-1/2 lg:w-1/3 w-full px-10 md:px-16 sm:pt-24 pt-10 relative sm:mr-4">
          <button
            type="button"
            className="w-fit h-12 sm:hidden mb-10 flex items-center cursor-pointer"
          >
            <img src="apollo_logo.svg" className="w-fit" alt="LOGO" />
          </button>
          {!superAdmin ? (
            <label className="text-white sm:pt-0 text-xl font-medium">
              {t("login.greeting")}
            </label>
          ) : null}
          {!superAdmin ? (
            <div className="pt-7 flex flex-col gap-2 h-full">
              <label className="font-semibold text-white text-sm">
                {t("masters.fields.username")}
              </label>
              <input
                type="text"
                name="userName"
                placeholder="Enter Username"
                value={user.userName}
                onChange={handleChange}
                className={`${
                  validate.userName === true
                    ? "border-red-800  bg-red-550"
                    : "border-blue-800 bg-white "
                } w-full h-14 placeholder-neutral-400 bg-white pl-5 border text-xs font-medium rounded-xl focus:outline-none`}
              ></input>
              {validate.userName && (
                <div className="text-xs font-normal flex gap-1 items-center text-red-600 mt-1">
                  <svg
                    width="15"
                    height="12"
                    viewBox="0 0 28 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.73802 1.96274L1.26802 16.1027C1.09339 16.4052 1.00099 16.748 1.00001 17.0973C0.99903 17.4465 1.08951 17.7899 1.26245 18.0933C1.43538 18.3967 1.68474 18.6495 1.98573 18.8266C2.28671 19.0037 2.62882 19.0989 2.97802 19.1027H19.918C20.2672 19.0989 20.6093 19.0037 20.9103 18.8266C21.2113 18.6495 21.4607 18.3967 21.6336 18.0933C21.8065 17.7899 21.897 17.4465 21.896 17.0973C21.8951 16.748 21.8027 16.4052 21.628 16.1027L13.158 1.96274C12.9797 1.66885 12.7287 1.42586 12.4292 1.25723C12.1297 1.08859 11.7918 1 11.448 1C11.1043 1 10.7663 1.08859 10.4668 1.25723C10.1673 1.42586 9.91629 1.66885 9.73802 1.96274Z"
                      stroke="#FF2828"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.4482 7.10278V11.1028"
                      stroke="#FF2828"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.4482 15.1028H11.4582"
                      stroke="#FF2828"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {t("login.username_error")}
                </div>
              )}
              <label className="font-semibold text-white text-sm mt-1">
                {t("masters.fields.password")}
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter Password"
                  value={user.password}
                  onChange={handleChange}
                  className={`${
                    validate.password === true || validate.passwordIncorrect
                      ? "border-red-600 bg-red-550 text-white"
                      : "border-blue-800 bg-white "
                  } w-full h-14 placeholder-neutral-400 pl-5 text-xs font-medium rounded-xl border focus:outline-none`}
                ></input>
                {validate.password && (
                  <div className="text-xs font-normal flex gap-1 items-center text-red-600 mt-1">
                    <svg
                      width="15"
                      height="12"
                      viewBox="0 0 28 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.73802 1.96274L1.26802 16.1027C1.09339 16.4052 1.00099 16.748 1.00001 17.0973C0.99903 17.4465 1.08951 17.7899 1.26245 18.0933C1.43538 18.3967 1.68474 18.6495 1.98573 18.8266C2.28671 19.0037 2.62882 19.0989 2.97802 19.1027H19.918C20.2672 19.0989 20.6093 19.0037 20.9103 18.8266C21.2113 18.6495 21.4607 18.3967 21.6336 18.0933C21.8065 17.7899 21.897 17.4465 21.896 17.0973C21.8951 16.748 21.8027 16.4052 21.628 16.1027L13.158 1.96274C12.9797 1.66885 12.7287 1.42586 12.4292 1.25723C12.1297 1.08859 11.7918 1 11.448 1C11.1043 1 10.7663 1.08859 10.4668 1.25723C10.1673 1.42586 9.91629 1.66885 9.73802 1.96274Z"
                        stroke="#FF2828"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.4482 7.10278V11.1028"
                        stroke="#FF2828"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.4482 15.1028H11.4582"
                        stroke="#FF2828"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {t("login.password_error")}
                  </div>
                )}
                <button
                  type="button"
                  className="bg-white"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6 absolute right-6 top-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6 absolute right-6 top-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                      />
                    </svg>
                  )}
                </button>
              </div>
              {validate.passwordIncorrect && user.password && (
                <div className="text-xs font-normal flex gap-1 items-center text-red-600 mt-1">
                  <svg
                    width="15"
                    height="12"
                    viewBox="0 0 28 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.73802 1.96274L1.26802 16.1027C1.09339 16.4052 1.00099 16.748 1.00001 17.0973C0.99903 17.4465 1.08951 17.7899 1.26245 18.0933C1.43538 18.3967 1.68474 18.6495 1.98573 18.8266C2.28671 19.0037 2.62882 19.0989 2.97802 19.1027H19.918C20.2672 19.0989 20.6093 19.0037 20.9103 18.8266C21.2113 18.6495 21.4607 18.3967 21.6336 18.0933C21.8065 17.7899 21.897 17.4465 21.896 17.0973C21.8951 16.748 21.8027 16.4052 21.628 16.1027L13.158 1.96274C12.9797 1.66885 12.7287 1.42586 12.4292 1.25723C12.1297 1.08859 11.7918 1 11.448 1C11.1043 1 10.7663 1.08859 10.4668 1.25723C10.1673 1.42586 9.91629 1.66885 9.73802 1.96274Z"
                      stroke="#FF2828"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.4482 7.10278V11.1028"
                      stroke="#FF2828"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.4482 15.1028H11.4582"
                      stroke="#FF2828"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {t("login.login_fail_error")}
                </div>
              )}

              <div className="flex mt-4 w-full justify-end items-center px-2">
                <button
                  type="button"
                  onClick={() => navigate("/resetPassword")}
                  className="text-sm font-medium text-center w-fit hover:underlinen text-orange-600 mt-3 underline "
                >
                  {t("login.forgot_password")}
                </button>
              </div>
              <div className="flex flex-col justify-center items-center">
                <button
                  type="submit"
                  className="bg-gradient-to-r flex justify-center items-center gap-2 from-red-800 disabled:opacity-40 to-orange-600 mt-4 text-white rounded-lg w-full h-14 font-semibold text-xs text-align-center"
                  onClick={onLoginClick}
                  disabled={loading}
                >
                  {loading && (
                    <svg class="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  )}
                  {t("login.login")}
                </button>
              </div>
              <div className="flex flex-col justify-between gap-2 mt-2">
                <GoogleLogin
                  className="flex w-full justify-center mx-auto login-with-btn"
                  clientId={Client_id}
                  onSuccess={(res) => responseGoogleSuccess(res)}
                  onFailure={(res) => responseGoogleFailure(res)}
                  cookiePolicy={"single_host_origin"}
                  disabledStyle={{
                    filter: "grayscale(100%)",
                    backgroundColor: "#ebebeb",
                    boxShadow:
                      "0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)",
                    cursor: "not-allowed",
                  }}
                  style={{ width: "100%", display: "flex" }}
                  isSignedIn={false}
                >
                  <span className="w-36 flex text-neutral-500 text-sm font-medium">
                    {t("login.login_with_google")}
                  </span>
                </GoogleLogin>

                <button
                  className="flex w-full bg-white py-3 rounded-sm"
                  onClick={() => msSignIn()}
                  disabledStyle={{
                    filter: "grayscale(100%)",
                    backgroundColor: "#ebebeb",
                    boxShadow:
                      "0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)",
                    cursor: "not-allowed",
                  }}
                >
                  <div className="flex justify-center px-3 text-neutral-500 text-sm font-medium items-center w-full gap-5">
                    <img src="microsoft-icon.svg" alt="MicroSoftIcon" />
                    <span className="w-36 flex">
                      {t("login.login_with_microsoft")}
                    </span>
                  </div>
                </button>
              </div>
              <div className="flex justify-center gap-5 md:gap-8 items-center mt-16 lg:mt-40 lg:pt-5 right-1/2 transform -translate-y-1/2 ">
                <label className="text-white text-xxs md:text-xs">
                  {t("login.powered_by")}{" "}
                </label>
                <img
                  src="GamberaDynamicsLogo.svg"
                  className="w-24 lg:w-28"
                  alt="gd-rms_logo"
                />
              </div>
            </div>
          ) : (
            <div className="flex flex-col h-full gap-2 justify-center">
              {/* <label className="text-neutral-400 text-base mb-14">
                Select the company you wish to monitor to proceed. Stay informed
                and stay ahead with our comprehensive monitoring tools. Choose
                from a range of companies to track their progress and
                performance.
              </label> */}
              <label className="text-white sm:pt-0 text-xl font-medium mb-20">
                {t("login.greeting")}
              </label>
              <label className="font-semibold text-white text-sm">
                {t("masters.fields.company")}
              </label>
              <div className="w-full h-14 loginform" id="loginform">
                <ComboBox
                  data={companies}
                  name="company"
                  dataItemKey="id"
                  textField="name"
                  placeholder={t("login.select_a_company")}
                  clearButton={false}
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    color: "black",
                  }}
                  className="block placeholder:text-white border-gray-700 rounded-xl bg-white text-white px-10 w-full h-full"
                  onChange={(e) => setCompany(e.value)}
                  value={company}
                />
              </div>
              <div className="flex flex-col justify-center items-center mt-10">
                <button
                  type="submit"
                  className="bg-gradient-to-r flex justify-center items-center gap-2 from-red-800 disabled:opacity-40 to-orange-600 mt-4 text-white rounded-lg w-full h-14 font-semibold text-xs text-align-center"
                  onClick={onCompanySubmit}
                  disabled={!company}
                >
                  {t("login.submit")}
                </button>
                <button
                  type="button"
                  onClick={() => setSuperAdmin(false)}
                  className="w-36 flex underline text-blue-500 text-xs font-medium mt-5"
                >
                  {t("login.go_back_to_login")}
                </button>
              </div>
            </div>
          )}
        </form>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ToastContainer />
      </div>
    </div>
  );
};

export default Login;
